import styled from 'styled-components';
import { StyledCard } from '../../../components/Card.component';

export const StyledCandidateRecordsHeaderTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin: 10px;
`;
export const StyledIconButtonWrapper = styled.div`
  margin: 10px 5px;
`;
export const StyledCandidateRecordsHeader = styled(StyledCard)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;
export const StyledCandidateRecords = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  transition: all 0.3s;
`;
export const StyledCandidateInfoTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`;
export const StyledCandidateInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;
export const StyledCandidateInfoBlocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledCandidatePage = styled.div`
  display: flex;
  height: calc(100vh - 60px);
  overflow: hidden;
  column-gap: 30px;
`;

export const StyledCandidatePageLeftSide = styled.div`
  width: 350px;
  min-width: 350px;
  padding: 40px 10px 40px 40px;
  overflow-y: scroll;
`;

export const StyledCandidatePageRightSide = styled.div`
  flex-grow: 1;
  overflow: scroll;
`;

export const StyledNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
